import { ChangeDetectionStrategy, Component, effect, inject, signal } from '@angular/core';
import { DotCMSPageAsset } from '@dotcms/types';

import { DotCmsUveFacade } from '../../facades/dot-cms-uve.facade';
import { ExtraContent } from '../../models/dot-cms-uve-contentlet.model';
import { PageState } from '../../models/dot-cms-uve.model';
import { DotCmsUveEditablePageService } from '../../services/dot-cms-uve-editable-page/dot-cms-uve-editable-page.service';
import { DotCmsUVEHeaderNavigationComponent } from '../dot-cms-uve-header-navigation/dot-cms-uve-header-navigation.component';

type DotCMSPage = {
  pageAsset: DotCMSPageAsset;
  content: ExtraContent;
};

@Component({
  selector: 'custom-dot-cms-uve-header',
  imports: [DotCmsUVEHeaderNavigationComponent],
  providers: [DotCmsUveEditablePageService],
  templateUrl: './dot-cms-uve-header.component.html',
  styleUrl: './dot-cms-uve-header.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DotCmsUveHeaderComponent {
  $pageState = signal<PageState<DotCMSPage>>(null);
  private dotCmsUveFacade = inject(DotCmsUveFacade);

  constructor() {
    effect(() => {
      const pageData = this.dotCmsUveFacade.pageState();
      this.$pageState.set(pageData);
    });
  }
}
